
{
  "actions": {
    "delete": "Delete",
    "edit": "Edit"
  },
  "add-label": "Add Review",
  "reviews-limit-reached": "Reviews limit reached. Delete a review before you can add another."
}
